import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { cn } from "@/lib/utils";
import { NAV } from "@/lib/testIds";
import { RESTAURANT } from "@/data/catalog";

const links = [
  { to: "/", label: "Accueil", testId: NAV.linkHome, end: true },
  { to: "/menu", label: "Menu", testId: NAV.linkMenu },
  { to: "/offres", label: "Offres", testId: "nav-link-offres" },
  { to: "/contact", label: "Contact", testId: NAV.linkContact },
];

const linkClasses = ({ isActive }) =>
  cn(
    "text-sm font-medium tracking-wide transition-colors",
    isActive
      ? "text-[#F5EFE6]"
      : "text-white/70 hover:text-[#F5EFE6]"
  );

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-[#262626] backdrop-blur-xl bg-[#0A0A0A]/85">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link
          to="/"
          data-testid={NAV.brand}
          className="flex items-center"
          onClick={() => setOpen(false)}
        >
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testId}
              className={linkClasses}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={RESTAURANT.phoneTel}
            data-testid={NAV.ctaCommander}
            className="font-street inline-flex items-center gap-2 rounded-md border border-[#F5EFE6]/20 bg-[#F5EFE6]/[0.04] px-5 py-2.5 text-sm tracking-wider text-[#F5EFE6] transition-all duration-200 hover:border-[#F5EFE6]/40 hover:bg-[#F5EFE6]/[0.08]"
          >
            <Phone size={15} strokeWidth={2.6} className="text-[#C9A875]" />
            Appeler maintenant
          </a>
        </div>

        <button
          type="button"
          className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg border border-[#262626] text-white"
          aria-label="Ouvrir le menu"
          data-testid={NAV.mobileToggle}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t border-[#262626] bg-[#0A0A0A]"
          data-testid={NAV.mobileSheet}
        >
          <nav className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`${l.testId}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  cn(
                    "rounded-md px-3 py-3 text-base font-medium",
                    isActive
                      ? "bg-[#F5EFE6]/[0.08] text-[#F5EFE6] border border-[#F5EFE6]/15"
                      : "text-white/80 hover:bg-[#171717]"
                  )
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={RESTAURANT.phoneTel}
              data-testid={`${NAV.ctaCommander}-mobile`}
              onClick={() => setOpen(false)}
              className="font-street mt-2 inline-flex items-center justify-center gap-2 rounded-md border border-[#F5EFE6]/25 bg-[#F5EFE6]/[0.04] px-5 py-3 text-sm tracking-wider text-[#F5EFE6]"
            >
              <Phone size={15} strokeWidth={2.6} className="text-[#C9A875]" />
              Appeler maintenant
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
